import { render, staticRenderFns } from "./BaiduIndex.vue?vue&type=template&id=29550d14&"
import script from "./BaiduIndex.vue?vue&type=script&lang=js&"
export * from "./BaiduIndex.vue?vue&type=script&lang=js&"
import style0 from "./BaiduIndex.vue?vue&type=style&index=0&id=29550d14&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports